import {workoutStressLabel} from '../../utils/workoutStressLabel';
import {resolveWorkoutTypeId} from '../../utils/workoutTypeMeta';
import type {BriefWorkout} from '../../services/api';
import {STATIC_WORKOUT_TYPES} from '../../data/staticSportData';
import {workoutTypeLabel} from '../../utils/sportLabel';
import {displayDigits} from '../../utils/displayDigits';
import {buildWorkoutRowMetrics} from '../calendar/calendarHelpers';

const GENERIC_TITLES: Record<string, number> = {
  run: 1, running: 1, bike: 2, cycling: 2, ride: 2, swim: 3, swimming: 3,
  brick: 4, crosstrain: 5, race: 6, 'day off': 7, 'mountain bike': 8,
  strength: 9, custom: 10, 'xc-ski': 11, rowing: 12, other: 13, walk: 14, walking: 14,
};

export function workoutRowText(workout: BriefWorkout, locale: string) {
  const fa = /^fa(?:-|$)/i.test(locale);
  const type = workout.workout_type;
  const typeId = resolveWorkoutTypeId(undefined, type?.english_name || type?.name);
  const localizedType = fa ? STATIC_WORKOUT_TYPES.find(item => item.id === typeId) ?? type : type;
  const sport = localizedType ? workoutTypeLabel({id: typeId ?? 0, name: localizedType.name ?? '', english_name: localizedType.english_name ?? '', icon: ''}, locale) : '';
  const originalTitle = workout.title?.trim() || sport;
  const generic = fa ? STATIC_WORKOUT_TYPES.find(item => item.id === GENERIC_TITLES[originalTitle.toLowerCase()]) : undefined;
  const title = generic ? workoutTypeLabel(generic, locale) : originalTitle;
  const metrics = buildWorkoutRowMetrics(workout).map(metric => fa
    ? displayDigits(metric.replace(/\bTSS\b/g, workoutStressLabel(workout) === 'hrTSS' ? 'hrTSS' : 'بار تمرین').replace(/\bkm\b/g, 'کیلومتر').replace(/\bm\b/g, 'متر').replace(/(\d)\.(?=\d)/g, '$1٫'), locale)
    : metric.replace(/\bTSS\b/g, workoutStressLabel(workout) === 'hrTSS' ? 'hrTSS' : 'TSS'));
  return {sport, title, metrics};
}
